import supplementsService from 'services/supplements.service'
import i18n from 'i18n'

const state = {
    hotels: [],

    accSupplements: [],
    accSupplementPrices: [],
    currentAccSupplement: {},
    defaultAccSupplement: {},

    mealSupplements: [],
    mealSupplementPrices: [],
    currentMealSupplement: {},
    defaultMealSupplement: {},

    isLoading: false,
    isSaving: false,
}

const getters = {
    
}

const mutations = {
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },

    setAccSupplements(state, supplements = []) {
        state.accSupplements = supplements;
    },
    setCurrentAccSupplement(state, supplement = {}) {
        state.currentAccSupplement = supplement;
    },
    setDefaultAccSupplement(state, supplement = {}) {
        state.defaultAccSupplement = supplement;
    },
    setAccSupplementPrices(state, supplementPrices = []) {
        state.accSupplementPrices = supplementPrices;
    },
    updateAccSupplementPrice(state, payload) {
        const { supplementPrice, index } = payload;
        state.accSupplementPrices.splice(index, 1, supplementPrice);
    },
    removeAccSupplementPrice(state, index) {
        state.accSupplementPrices.splice(index, 1);
    },

    setMealSupplements(state, supplements = []) {
        state.mealSupplements = supplements;
    },
    setCurrentMealSupplement(state, supplement = {}) {
        state.currentMealSupplement = supplement;
    },
    setDefaultMealSupplement(state, supplement = {}) {
        state.defaultMealSupplement = supplement;
    },
    setMealSupplementPrices(state, supplementPrices = []) {
        state.mealSupplementPrices = supplementPrices;
    },
    updateMealSupplementPrice(state, payload) {
        const { supplementPrice, index } = payload;
        state.mealSupplementPrices.splice(index, 1, supplementPrice);
    },
    removeMealSupplementPrice(state, index) {
        state.mealSupplementPrices.splice(index, 1);
    },

    setIsLoading(state, status = false) {
        state.isLoading = status;
    },
    setIsSaving(state, status = false) {
        state.isSaving = status;
    },


}

const actions = {
    getHotels ({ commit }) {
        return supplementsService.getHotels().then(response => {
            if (response.length > 1) {
                response.unshift({ label: i18n.global.t('components.all'), value: 0 });
            }
            commit('setHotels', response);
        }).catch(error => {
            console.log(error);
        });
    },
    getAccSupplements({ commit }, params) {
        return supplementsService.getAccSupplements(params).then(response => {
            commit('setAccSupplements', response);
        }).catch(error => {
            console.log(error);
        });
    },

    getAccSupplementPrices({ commit }, params) {
        return supplementsService.getAccSupplementPrices(params).then(response => {
            commit('setAccSupplementPrices', response);
        }).catch(error => {
            console.log(error);
        });
    },

    setAccSupplement({ state, commit }, options = {}) {
        commit('setIsSaving', true);
        let prices = options.cancel ? state.defaultAccSupplement.prices : state.accSupplementPrices;
        prices = prices.map(price => {
            return {
                "inc": price.id,
                "paxtype": price.pax_type,
                "bedtype": price.bed_type,
                "cagefrom": price.age_from,
                "cageto": price.age_to,
                "price": price.price,
                "room": price.room,
                "mealincluded":price.meal_included,
                "ispercent": price.is_percent,
                "paxindex": price.pax_index,
            };
        })
        const supplement = options.cancel ? state.defaultAccSupplement : state.currentAccSupplement;
        const params = {
            ...supplement,
            id: options.saveAs ? null : state.currentAccSupplement.id,
            price_data: JSON.stringify({
                accSupplementPrices: prices,
            }),
        };
        return supplementsService.setAccSupplement(params).then(response => {
            console.log(response);
            commit('setCurrentAccSupplement', {
                ...state.currentAccSupplement,
                id: response.id,
            });
        }).finally(() => {
            commit('setIsSaving', false);
        });
    },

    deleteAccSupplement({ commit }, params) {
        commit('setIsSaving', true);
        return supplementsService.deleteAccSupplement(params).then(response => {
        }).catch(error => {
            throw error;
        }).finally(() => {
            commit('setIsSaving', false);
        });
    },

    getMealSupplements({ commit }, params) {
        return supplementsService.getMealSupplements(params).then(response => {
            commit('setMealSupplements', response);
        }).catch(error => {
            console.log(error);
        });
    },

    getMealSupplementPrices({ commit }, params) {
        return supplementsService.getMealSupplementPrices(params).then(response => {
            commit('setMealSupplementPrices', response);
        }).catch(error => {
            console.log(error);
        });
    },

    setMealSupplement({ state, commit }, options = {}) {
        commit('setIsSaving', true);
        let prices = options.cancel ? state.defaultMealSupplement.prices : state.mealSupplementPrices;
        prices = prices.map(price => {
            return {
                "inc": price.id,
                "paxtype": price.pax_type,
                "cagefrom": price.age_from,
                "cageto": price.age_to,
                "price": price.price,
                "room": price.room,
                "meal":price.meal,
                "ispercent": price.is_percent,
                "paxindex": price.pax_index,
            };
        })
        const supplement = options.cancel ? state.defaultMealSupplement : state.currentMealSupplement;
        const params = {
            ...supplement,
            id: options.saveAs ? null : state.currentMealSupplement.id,
            price_data: JSON.stringify({
                mealSupplementPrices: prices,
            }),
        };
        return supplementsService.setMealSupplement(params).then(response => {
            commit('setCurrentMealSupplement', {
                ...state.currentMealSupplement,
                id: response.id,
            });
        }).finally(() => {
            commit('setIsSaving', false);
        });
    },

    deleteMealSupplement({ commit }, params) {
        commit('setIsSaving', true);
        return supplementsService.deleteMealSupplement(params).then(response => {
        }).catch(error => {
            throw error;
        }).finally(() => {
            commit('setIsSaving', false);
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
